import dayjs from "dayjs";
import user1 from "../assets/images/user1.png";
import user2 from "../assets/images/user2.png";
import user3 from "../assets/images/user3.png";
import user4 from "../assets/images/user4.png";
import user5 from "../assets/images/user5.png";
import user6 from "../assets/images/user6.png";
import user7 from "../assets/images/user7.svg";
export const Data = [
  {
    Bill: "#BILL000022",
    date: "9 Apr 2024",
    dueDate: "15 Apr 2024",
    amountDue: "$163",
    category: "development",
    name: "Mayor kelly",
    email: "mayorkelly@example.com",
  },
  {
    Bill: "#BILL000022",
    date: "9 Apr 2024",
    dueDate: "15 Apr 2024",
    amountDue: "$163",
    category: "development",
    name: "Mayor kelly",
    email: "mayorkelly@example.com",
  },
  {
    Bill: "#BILL000022",
    date: "9 Apr 2024",
    dueDate: "15 Apr 2024",
    amountDue: "$163",
    category: "development",
    name: "Mayor kelly",
    email: "mayorkelly@example.com",
  },

  {
    Bill: "#BILL000022",
    date: "9 Apr 2024",
    dueDate: "15 Apr 2024",
    amountDue: "$163",
    category: "development",
    name: "Mayor kelly",
    email: "mayorkelly@example.com",
  },

  {
    Bill: "#BILL000022",
    date: "9 Apr 2024",
    dueDate: "15 Apr 2024",
    amountDue: "$163",
    category: "development",
    name: "Mayor kelly",
    email: "mayorkelly@example.com",
  },

  {
    Bill: "#BILL000022",
    date: "9 Apr 2024",
    dueDate: "15 Apr 2024",
    amountDue: "$163",
    category: "development",
    name: "Mayor kelly",
    email: "mayorkelly@example.com",
  },
  {
    Bill: "#BILL000022",
    date: "9 Apr 2024",
    dueDate: "15 Apr 2024",
    amountDue: "$163",
    category: "development",
    name: "Mayor kelly",
    email: "mayorkelly@example.com",
  },

  {
    Bill: "#BILL000022",
    date: "9 Apr 2024",
    dueDate: "15 Apr 2024",
    amountDue: "$163",
    category: "development",
    name: "Mayor kelly",
    email: "mayorkelly@example.com",
  },
];

export const paymentTermsOptions = [
  { label: "Immediate", value: "Immediate" },
  { label: "Net 7", value: "Net 7" },
  { label: "Net 15", value: "Net 15" },
  { label: "Net 30", value: "Net 30" },
  { label: "Net 45", value: "Net 45" },
  { label: "Net 60", value: "Net 60" },
  { label: "End of the Month", value: "End of the Month" },
  { label: "End of the next Month", value: "End of the next Month" },
  { label: "Custom", value: "Custom" },
];

export const paidViaOptions = [
  { label: "Bank Remittance", value: "Bank Remittance" },
  { label: "Bank Transfer", value: "Bank Transfer" },
  { label: "Cheque", value: "Cheque" },
  { label: "Credit Card", value: "Credit Card" },
  { label: "UPI", value: "UPI" },
];

export const TDSOptions = [
  { label: "TDS 1", value: "TDS 1" },
  { label: "TDS 2", value: "TDS 2" },
];

export const transferFromAccountOptions = [
  { label: "Other Current Assets", value: "Other Current Assets" },
  { label: "Cash", value: "Cash" },
  { label: "Equity", value: "Equity" },
];

export const otherIncomeFromAccountOptions = [
  { label: "Discount", value: "Discount" },
  { label: "General Income", value: "General Income" },
  { label: "Late Fee Income", value: "Late Fee Income" },
  { label: "Other Charges", value: "Other Charges" },
  { label: "Shipping Charges", value: "Shipping Charges" },
];

export const expenseRefundFromAccountOptions = [
  { label: "Other Current Asset", value: "Other Current Asset" },
  { label: "Fixed Asset", value: "Fixed Asset" },
  { label: "Other Current Liability", value: "Other Current Liability" },
  { label: "Expense", value: "Expense" },
  { label: "Cost of Goods Sold", value: "Cost of Goods Sold" },
  { label: "Other Expense", value: "Other Expense" },
];

export const depositsFromOtherFromAccountOptions = [
  { label: "Other Current Asset", value: "Other Current Asset" },
  { label: "Cash", value: "Cash" },
  { label: "Fixed Asset", value: "Fixed Asset" },
  { label: "Stock", value: "Stock" },
  { label: "Other Current Liability", value: "Other Current Liability" },
  { label: "Non Current Liability", value: "Non Current Liability" },
  { label: "Equity", value: "Equity" },
  { label: "Income", value: "Income" },
];

export const ownersContributionFromAccountOptions = [
  { label: "Capital Stocks", value: "Capital Stocks" },
  { label: "Distributions", value: "Distributions" },
  { label: "Dividends Paid", value: "Dividends Paid" },
  { label: "Drawings", value: "Drawings" },
  { label: "Investments", value: "Investments" },
  { label: "Opening Balance Offset", value: "Opening Balance Offset" },
  { label: "Owners Equity", value: "Owners Equity" },
];

export const expenseAccountOptions = [
  { label: "Other Current Asset", value: "Other Current Asset" },
  { label: "Fixed Asset", value: "Fixed Asset" },
  { label: "Other Current Liability", value: "Other Current Liability" },
  { label: "Non Current Liability", value: "Non Current Liability" },
  { label: "Expense", value: "Expense" },
  { label: "Cost of Goods Sold", value: "Cost of Goods Sold" },
];

export const transferToAccountOptions = [
  { label: "Other Current Assets", value: "Other Current Assets" },
  { label: "Cash", value: "Cash" },
  { label: "Equity", value: "Equity" },
];

export const ownersDrawingToAccountOptions = [
  { label: "Capital Stocks", value: "Capital Stocks" },
  { label: "Distributions", value: "Distributions" },
  { label: "Dividends Paid", value: "Dividends Paid" },
  { label: "Drawings", value: "Drawings" },
  { label: "Investments", value: "Investments" },
  { label: "Opening Balance Offset", value: "Opening Balance Offset" },
  { label: "Owners Equity", value: "Owners Equity" },
];

export const depreciationOptions = [
  { label: "Straight Line", value: "Straight Line" },
  { label: "Declining Balance", value: "Declining Balance" },
  { label: "Double Declining Balance", value: "Double Declining Balance" },
  { label: "Custom", value: "Custom" },
];
export const assetAccount = [
  { label: "Fixed Assets", value: "Fixed Assets" },
  { label: "Other Current Assets", value: "Other Current Assets" },
];
export const assetTypeOptions = [
  { label: "Fixed Asset", value: "Fixed Asset" },
  { label: "Intangible Asset", value: "Intangible Asset" },
];

export const computationTypeOptions = [
  { label: "Non Pro Rata", value: "Non Pro Rata" },
  { label: "Pro Rata", value: "Pro Rata" },
];
export const accumulatedDepreciationAccount = [
  { label: "Fixed Assets", value: "Fixed Assets" },
  { label: "Other Current Assets", value: "Other Current Assets" },
];
export const depreciationMethodOptions = [
  { label: "Straight Line", value: "Straight Line" },
  { label: "Declining Balance", value: "Declining Balance" },
];
export const depreciationFrequencyOptions = [
  { label: "Monthly", value: "Monthly" },
  { label: "Yearly", value: "Yearly" },
];
export const assetLifeCounterTypeOptions = [
  { label: "Months", value: "Months" },
  { label: "Days", value: "Days" },
];

export const accountOptions = [
  { label: "Other Current Assets", value: "Other Current Assets" },
  { label: "Fixed Assets", value: "Fixed Assets" },
  { label: "Other Current Liabilities", value: "Other Current Liabilities" },
  { label: "Equity", value: "Equity" },
  { label: "Income", value: "Income" },
  { label: "Expenses", value: "Expenses" },
  { label: "Cost of Goods Sold", value: "Cost of Goods Sold" },
];

export const invoiceTypeOptions = [
  { label: "One-Time", value: "One-Time" },
  { label: "Daily", value: "Daily" },
  { label: "Weekly", value: "Weekly" },
  { label: "Monthly", value: "Monthly" },
  { label: "Quarterly", value: "Quarterly" },
  { label: "Yearly", value: "Yearly" },
];
export const data = [
  {
    client: "Global Technology",
    number: "#INV-0001",
    date: "15 Apr 2024",
    duedate: "19 Apr 2024",
    amount: "$163",
    name: "Mayor kelly",
    pic: user1,
  },
  {
    client: "Global Technology",
    number: "#INV-0001",
    date: "15 Apr 2024",
    duedate: "19 Apr 2024",
    amount: "$163",
    name: "Mayor kelly",
    pic: user2,
  },
  {
    client: "Global Technology",
    number: "#INV-0001",
    date: "15 Apr 2024",
    duedate: "19 Apr 2024",
    amount: "$163",
    name: "Mayor kelly",
    pic: user3,
  },
  {
    client: "Global Technology",
    number: "#INV-0001",
    date: "15 Apr 2024",
    duedate: "19 Apr 2024",
    amount: "$163",
    name: "Mayor kelly",
    pic: user4,
  },
];
export const ProfitData = [
  {
    type: "Sales Account",
    total: "$3000",
    amount: "$163",
    var: "$300",
    overall: "$30000",
  },
  {
    type: "Opening Stock",
    total: "$3000",
    amount: "$163",
    var: "$300",
    overall: "$30000",
  },
  {
    type: "Cost of Sales",
    total: "$3000",
    amount: "$163",
    var: "$300",
    overall: "$30000",
  },
  {
    type: "Closing Stock",
    total: "$3000",
    amount: "$163",
    var: "$300",
    overall: "$30000",
  },
];
export const BalanceData = [
  {
    liablities: "Creditors",
    amount: "$3000",
    assets: "cash",
    amounts: 0,
  },
  {
    liablities: "Capital",
    amount: "$1000",
    assets: "Debtors",
    amounts: 0,
  },
  {
    liablities: "Net Loss",
    amount: "$5230",
    assets: "stock",
    amounts: 0,
  },
  {
    liablities: "Less Drawings",
    amount: "$0",
    assets: "By Bank",
    amounts: 4300,
  },
  {
    liablities: "",
    amount: "",
    assets: "Laptop",
    amounts: "$0",
  },
  {
    liablities: "",
    amount: "",
    assets: "Office Executive Table",
    amounts: "$300",
  },
];

export const AttendanceReq = {
  checkIn: {
    value: "",
    error: "",
    focus: null,
  },
  checkOut: {
    value: "",
    error: "",
    focus: null,
  },
  remarks: {
    value: "",
    error: "",
    focus: null,
  },
};
export const AddNewEmployeeData = {
  firstName: {
    value: "",
    error: "",
    focus: null,
  },
  nickName: {
    value: "",
    error: "",
    focus: null,
  },
  empNumber: {
    value: "",
    error: "",
    focus: null,
  },

  rate: {
    value: "",
    error: "",
    focus: null,
  },

  extraTimeRate: {
    value: "",
    error: "",
    focus: null,
  },
  doubleOverTimeRate: {
    value: "",
    error: "",
    focus: null,
  },

  lastName: {
    value: "",
    error: "",
    focus: null,
  },
  gender: {
    value: "",
    error: "",
    focus: null,
  },
  empType: {
    value: "",
    error: "",
    focus: null,
  },

  cCode: {
    value: "",
    error: "",
    focus: null,
  },

  mobile: {
    value: "",
    error: "",
    focus: null,
  },
  type: {
    value: "",
    error: "",
    focus: null,
  },
  amount: {
    value: "",
    error: "",
    focus: null,
  },

  password: {
    value: "",
    error: "",
    focus: null,
  },
  confirmPassword: {
    value: "",
    error: "",
    focus: null,
  },
  jobPosition: {
    value: "",
    error: "",
    focus: null,
  },
  department: {
    value: "",
    error: "",
    focus: null,
  },
  operator: {
    value: "",
    error: "",
    focus: null,
  },
  address1: {
    value: "",
    error: "",
    focus: null,
  },
  address2: {
    value: "",
    error: "",
    focus: null,
  },
  city: {
    value: "",
    error: "",
    focus: null,
  },
  zipCode: {
    value: "",
    error: "",
    focus: null,
  },
  country: {
    value: "",
    error: "",
    focus: null,
  },
  accountType: {
    value: "",
    error: "",
    focus: null,
  },
  email: {
    value: "",
    error: "",
    focus: null,
  },
  dob: {
    value: "",
    error: "",
    focus: null,
  },
  issuedDate: {
    value: dayjs(),
    error: "",
    focus: null,
  },
  education: {
    value: "",
    error: "",
    focus: null,
  },
  salary: {
    value: "",
    error: "",
    focus: null,
  },
  payrollName: {
    value: "",
    error: "",
    focus: null,
  },
  leaveBalance: {
    value: "",
    error: "",
    focus: null,
  },
  restraintTrade: {
    value: "",
    error: "",
    focus: null,
  },
  travelAll: {
    value: "",
    error: "",
    focus: null,
  },
  annualBonus: {
    value: "",
    error: "",
    focus: null,
  },
  payfreq: {
    value: "",
    error: "",
    focus: null,
  },
  paymentType: {
    value: "",
    error: "",
    focus: null,
  },
  rateRembTravel: {
    value: "",
    error: "",
    focus: null,
  },
  isActive: {
    value: true,
    error: "",
    focus: null,
  },
  increment: {
    value: "",
    error: "",
    focus: null,
  },
  profileImg: {
    value: "",
    error: "",
    focus: null,
  },
  nationality: {
    value: "",
    error: "",
    focus: null,
  },
  religion: {
    value: "",
    error: "",
    focus: null,
  },
  marital: {
    value: "",
    error: "",
    focus: null,
  },
  passportNum: {
    value: "",
    error: "",
    focus: null,
  },
  emergencyContact: {
    value: "",
    error: "",
    focus: null,
  },
  workplace: {
    value: "",
    error: "",
    focus: null,
  },
  status: {
    value: "",
    error: "",
    focus: null,
  },
  hourlyRate: {
    value: "",
    error: "",
    focus: null,
  },
  bankName: {
    value: "",
    error: "",
    focus: null,
  },
  accountNum: {
    value: "",
    error: "",
    focus: null,
  },
  ifscCode: {
    value: "",
    error: "",
    focus: null,
  },
  accountHolder: {
    value: "",
    error: "",
    focus: null,
  },
  personalTaxCode: {
    value: "",
    error: "",
    focus: null,
  },
  joiningDate: {
    value: dayjs(),
    error: "",
    focus: null,
  },

  start: {
    value: dayjs(),
    error: "",
    focus: null,
  },
  end: {
    value: dayjs(),
    error: "",
    focus: null,
  },

  experience: {
    value: "",
    error: "",
    focus: null,
  },
  profileVisiblity: {
    value: false,
    error: "",
    focus: null,
  },
  preAttendance: {
    value: false,
    error: "",
    focus: null,
  },
  taskNoti: {
    value: false,
    error: "",
    focus: null,
  },
  urlSkype: {
    value: "",
    error: "",
    focus: null,
  },
  urlLinkedin: {
    value: "",
    error: "",
    focus: null,
  },
  urlInsta: {
    value: "",
    error: "",
    focus: null,
  },
  urlFb: {
    value: "",
    error: "",
    focus: null,
  },
  idNumber: {
    value: "",
    error: "",
    focus: null,
  },
  taxRefNo: {
    value: "",
    error: "",
    focus: null,
  },
  medicalAidNo: {
    value: "",
    error: "",
    focus: null,
  },
};
export const AddNewRecruitment = {
  position: {
    value: "",
    error: "",
    focus: null,
  },
  company: {
    value: "",
    error: "",
    focus: null,
  },
  quantity: {
    value: "",
    error: "",
    focus: null,
  },
  workingFrom: {
    value: "",
    error: "",
    focus: null,
  },
  department: {
    value: "",
    error: "",
    focus: null,
  },
  workplace: {
    value: "",
    error: "",
    focus: null,
  },

  startingSalaryFrom: {
    value: "",
    error: "",
    focus: null,
  },
  startingSalaryTo: {
    value: "",
    error: "",
    focus: null,
  },
  displaySalary: {
    value: "",
    error: "",
    focus: null,
  },
  reason: {
    value: "",
    error: "",
    focus: null,
  },
  desc: {
    value: "",
    error: "",
    focus: null,
  },
};
export const loginData = {
  email: {
    value: "",
    error: "",
    focus: null,
  },
  password: {
    value: "",
    error: "",
    focus: null,
  },
};
export const signUpData = {
  firstName: {
    value: "",
    error: "",
    focus: null,
  },
  lastName: {
    value: "",
    error: "",
    focus: null,
  },
  email: {
    value: "",
    error: "",
    focus: null,
  },
  password: {
    value: "",
    error: "",
    focus: null,
  },
  confirmPassword: {
    value: "",
    error: "",
    focus: null,
  },
  phone: {
    value: "",
    error: "",
    focus: null,
  },
  countryCode: {
    value: "+1",
    error: "",
    focus: null,
  },
  terms: {
    value: "",
    error: "",
    focus: null,
  },
};
export const companyInfoData = {
  companyName: {
    value: "",
    error: "",
    focus: null,
  },
  owner: {
    value: "",
    error: "",
    focus: null,
  },
  email: {
    value: "",
    error: "",
    focus: null,
  },
  city: {
    value: "",
    error: "",
    focus: null,
  },
  states: {
    value: "",
    error: "",
    focus: null,
  },

  country: {
    value: "",
    error: "",
    focus: null,
  },
  zipCode: {
    value: "",
    error: "",
    focus: null,
  },
  industry: {
    value: "",
    error: "",
    focus: null,
  },
};
export const accountSettingData = {
  companyName: {
    value: "",
    error: "",
    focus: null,
  },
  email: {
    value: "",
    error: "",
    focus: null,
  },
  incomeTax: {
    value: "",
    error: "",
    focus: null,
  },

  phone: {
    value: "",
    error: "",
    focus: null,
  },
  addressLine1: {
    value: "",
    error: "",
    focus: null,
  },
  addressLine2: {
    value: "",
    error: "",
    focus: null,
  },
  city: {
    value: "",
    error: "",
    focus: null,
  },
  states: {
    value: "",
    error: "",
    focus: null,
  },
  zipCode: {
    value: "",
    error: "",
    focus: null,
  },
  country: {
    value: "",
    error: "",
    focus: null,
  },
  region: {
    value: "",
    error: "",
    focus: null,
  },
  companyRegistrationNumber: {
    value: "",
    error: "",
    focus: null,
  },
  number: {
    value: "",
    error: "",
    focus: null,
  },
  currency: {
    value: "",
    error: "",
    focus: null,
  },
  addLeaveType: {
    value: "",
    error: "",
    focus: null,
  },
  cellNumber: {
    value: "",
    error: "",
    focus: null,
  },
  format: {
    value: "format1",
    error: "",
    focus: null,
  },
};
export const perfData = [
  {
    profile: user7,
    name: "Anvi",
    role: "Designer",
    rating: "90%",
  },
  {
    profile: user6,
    name: "Brandon",
    role: "Web Developer",
    rating: "88%",
  },

  {
    profile: user1,
    name: "Kevin Gill",
    role: "React Developer",
    rating: "80%",
  },
  {
    profile: user2,
    name: "Stacy",
    role: "Graphic Designer",
    rating: "77%",
  },

  {
    profile: user3,
    name: "Julia",
    role: "Sales",
    rating: "70%",
  },

  {
    profile: user4,
    name: "Merry",
    role: "Marketing",
    rating: "69%",
  },
  {
    profile: user5,
    name: "Lily",
    role: "UI/UX Developer",
    rating: "62%",
  },
];

export const itemsData = {
  itemTitle: {
    value: "",
    error: "",
    focus: null,
  },
  description: {
    value: "",
    error: "",
    focus: null,
  },
  sku: {
    value: "",
    error: "",
    focus: null,
  },
  unit: {
    value: "",
    error: "",
    focus: null,
  },
  barcodeType: {
    value: "",
    error: "",
    focus: null,
  },
  category: {
    value: "",
    error: "",
    focus: null,
  },
  subCategory: {
    value: "",
    error: "",
    focus: null,
  },
  bussinessLocation: {
    value: "",
    error: "",
    focus: null,
  },
  manageStock: {
    value: "",
    error: "",
    focus: null,
  },
  alertQuantity: {
    value: "",
    error: "",
    focus: null,
  },
  weight: {
    value: "",
    error: "",
    focus: null,
  },

  purchasePrice: {
    value: "",
    error: "",
    focus: null,
  },
  sellingPrice: {
    value: "",
    error: "",
    focus: null,
  },
  tax: {
    value: "",
    error: "",
    focus: null,
  },
  discount: {
    value: "",
    error: "",
    focus: null,
  },
  stockQuantity: {
    value: "",
    error: "",
    focus: null,
  },
};
export const createBank = {
  bankName: {
    value: "",
    error: "",
    focus: null,
  },
  branch: {
    value: "",
    error: "",
    focus: null,
  },

  accountHolder: {
    value: "",
    error: "",
    focus: null,
  },
  accountNumber: {
    value: "",
    error: "",
    focus: null,
  },
  cCode: {
    value: "",
    error: "",
    focus: null,
  },

  mobile: {
    value: "",
    error: "",
    focus: null,
  },
  initialBalance: {
    value: "",
    error: "",
    focus: null,
  },
  internetBanking: {
    value: "",
    error: "",
    focus: null,
  },
  swiftCode: {
    value: "",
    error: "",
    focus: null,
  },
};
export const addBank = {
  accountName: {
    value: "",
    error: "",
    focus: null,
  },
  accountCode: {
    value: "",
    error: "",
    focus: null,
  },
  currency: {
    value: "USD",
    error: "",
    focus: null,
  },
  accountNumber: {
    value: "",
    error: "",
    focus: null,
  },
  bankName: {
    value: "",
    error: "",
    focus: null,
  },
  ifsc: {
    value: "",
    error: "",
    focus: null,
  },
  description: {
    value: "",
    error: "",
    focus: null,
  },
};
export const addUserData = {
  name: {
    value: "",
    error: "",
    focus: null,
  },
  idNumber: {
    value: "",
    error: "",
    focus: null,
  },
  nationality: {
    value: "",
    error: "",
    focus: null,
  },
  email: {
    value: "",
    error: "",
    focus: null,
  },
  address: {
    value: "",
    error: "",
    focus: null,
  },
  city: {
    value: "",
    error: "",
    focus: null,
  },
  country: {
    value: "",
    error: "",
    focus: null,
  },
  zipCode: {
    value: "",
    error: "",
    focus: null,
  },
  department: {
    value: "",
    error: "",
    focus: null,
  },
  designation: {
    value: "",
    error: "",
    focus: null,
  },
  employeeID: {
    value: "",
    error: "",
    focus: null,
  },
};
export const addExpense = {
  name: {
    value: "",
    error: "",
    focus: null,
  },
  amount: {
    value: "",
    error: "",
    focus: null,
  },
  taxAmount: {
    value: "",
    error: "",
    focus: null,
  },
  description: {
    value: "",
    error: "",
    focus: null,
  },
};
export const addNewCustomerData = {
  name: {
    value: "",
    error: "",
    focus: null,
  },
  companyName: {
    value: "",
    error: "",
    focus: null,
  },
  email: {
    value: "",
    error: "",
    focus: null,
  },
  phone: {
    value: "",
    error: "",
    focus: null,
  },
  taxId: {
    value: "",
    error: "",
    focus: null,
  },
  creditLimits: { value: "", error: "", focus: null },
  street1: { value: "", error: "", focus: null },
  street2: { value: "", error: "", focus: null },
  city: { value: "", error: "", focus: null },
  city2: { value: "", error: "", focus: null },
  pinCode: { value: "", error: "", focus: null },
  pinCode1: { value: "", error: "", focus: null },
  state1: { value: "", error: "", focus: null },
  state2: { value: "", error: "", focus: null },
};
export const addNewSupplierData = {
  name: {
    value: "",
    error: "",
    focus: null,
  },
  email: {
    value: "",
    error: "",
    focus: null,
  },
  phone: {
    value: "",
    error: "",
    focus: null,
  },
  creditLimits: {
    value: "",
    error: "",
    focus: null,
  },
};
export const addPurchaseData = {
  supplierName: {
    value: "",
    error: "",
    focus: null,
  },
  billDate: {
    value: "",
    error: "",
    focus: null,
  },
  dueDate: {
    value: "",
    error: "",
    focus: null,
  },
  category: {
    value: "",
    error: "",
    focus: null,
  },
  product: {
    value: "",
    error: "",
    focus: null,
  },
  discount: {
    value: "",
    error: "",
    focus: null,
  },
  tax: {
    value: "",
    error: "",
    focus: null,
  },
  billNumber: {
    value: "",
    error: "",
    focus: null,
  },
  paymentStatus: {
    value: "",
    error: "",
    focus: null,
  },
  selectedCurrency: {
    value: "",
    error: "",
    focus: null,
  },
  remarks: {
    value: "",
    error: "",
    focus: null,
  },
  orderNumber: {
    value: "",
    error: "",
    focus: null,
  },
  grandTotal: {
    value: "",
    error: "",
    focus: null,
  },
  totalAmount: {
    value: "",
    error: "",
    focus: null,
  },
};
export const addInvoice = () => {
  return {
    invNumber: {
      value: "",
      error: "",
      focus: null,
    },
    cName: {
      value: "",
      error: "",
      focus: null,
    },
    client: {
      value: "",
      error: "",
      focus: null,
    },
    project: {
      value: "",
      error: "",
      focus: null,
    },
    phone: {
      value: "",
      error: "",
      focus: null,
    },
    clientAddress: {
      value: "",
      error: "",
      focus: null,
    },
    billingAddress: {
      value: "",
      error: "",
      focus: null,
    },

    tax: {
      value: "",
      error: "",
      focus: null,
    },
    invoiceDate: {
      value: "",
      error: "",
      focus: null,
    },
    dueDate: {
      value: "",
      error: "",
      focus: null,
    },
    productName: {
      value: "",
      error: "",
      focus: null,
    },
    description: {
      value: "",
      error: "",
      focus: null,
    },
    unitCost: {
      value: "",
      error: "",
      focus: null,
    },
    qty: {
      value: "",
      error: "",
      focus: null,
    },
    amount: {
      value: "",
      error: "",
      focus: null,
    },
    discount: {
      value: "",
      error: "",
      focus: null,
    },

    optional: {
      value: "",
      error: "",
      focus: null,
    },
  };
};
export const addBill = {
  supplier: {
    value: "",
    error: "",
    focus: null,
  },
  billNumber: {
    value: "",
    error: "",
    focus: null,
  },
  category: {
    value: "",
    error: "",
    focus: null,
  },
  orderNumber: {
    value: "",
    error: "",
    focus: null,
  },
  billDate: {
    value: "",
    error: "",
    focus: null,
  },
  dueDate: {
    value: "",
    error: "",
    focus: null,
  },
  productName: {
    value: "",
    error: "",
    focus: null,
  },
  description: {
    value: "",
    error: "",
    focus: null,
  },
  unitCost: {
    value: "",
    error: "",
    focus: null,
  },
  qty: {
    value: "",
    error: "",
    focus: null,
  },
  amount: {
    value: "",
    error: "",
    focus: null,
  },
};
export const payslipData = {
  employeeName: {
    value: "",
    error: "",
    focus: null,
  },
  totalTravel: {
    value: "",
    error: "",
    focus: null,
  },

  employeeNumber: {
    value: "",
    error: "",
    focus: null,
  },
  isShow: {
    value: "",
    error: "",
    focus: null,
  },

  overtime: {
    value: "",
    error: "",
    focus: null,
  },
  doublOvertime: {
    value: "",
    error: "",
    focus: null,
  },
  rate: {
    value: "",
    error: "",
    focus: "",
  },
  salaryPHr: {
    value: "",
    error: "",
    focus: null,
  },
  restraintTrade: {
    value: "",
    error: "",
    focus: null,
  },
  travelAllowance: {
    value: "",
    error: "",
    focus: null,
  },
  reimbursiveTravel: {
    value: "",
    error: "",
    focus: null,
  },
  reimbursiveRate: {
    value: "",
    error: "",
    focus: null,
  },

  contributionCompany: {
    value: "",
    error: "",
    focus: null,
  },
  pensionEmployee: {
    value: "",
    error: "",
    focus: null,
  },
  employeeMedical: {
    value: "",
    error: "",
    focus: null,
  },
  nightShiftAllowance: {
    value: "",
    error: "",
    focus: null,
  },
  subsistence: {
    value: "",
    error: "",
    focus: null,
  },
  allowances: {
    value: "",
    error: "",
    focus: null,
  },
  commission: {
    value: "",
    error: "",
    focus: null,
  },

  taxCredit: {
    value: "",
    error: "",
    focus: null,
  },
  nettTax: {
    value: "",
    error: "",
    focus: null,
  },
  calculatedTax: {
    value: "",
    error: "",
    focus: null,
  },
  taxable: {
    value: "",
    error: "",
    focus: null,
  },
  totalTax: {
    value: "",
    error: "",
    focus: null,
  },
  voluntaryTax: {
    value: "",
    error: "",
    focus: null,
  },
  fringeBenefit: {
    value: "",
    error: "",
    focus: null,
  },
  allDeductions: {
    value: "",
    error: "",
    focus: null,
  },
  loanRepayment: {
    value: "",
    error: "",
    focus: null,
  },
  uifIncome: {
    value: "",
    error: "",
    focus: null,
  },
  uif: {
    value: "",
    error: "",
    focus: null,
  },
  employerLevies: {
    value: "",
    error: "",
    focus: null,
  },
  incomeProtection: {
    value: "",
    error: "",
    focus: null,
  },
  leave: {
    value: "",
    error: "",
    focus: null,
  },
  grossIncome: {
    value: "",
    error: "",
    focus: null,
  },
  totalDeductions: {
    value: "",
    error: "",
    focus: null,
  },
  nettPay: {
    value: "",
    error: "",
    focus: null,
  },
  reibursements: {
    value: "",
    error: "",
    focus: null,
  },
  payable: {
    value: "",
    error: "",
    focus: null,
  },
};


export const SPECIAL_PROJECTS = {
  DEDUCTION: {
    id: "68b00d5d11bedff11e8d4cf1",
    name: "Deduction",
    value: "Deduction"
  },
  HOLIDAY: {
    id: "68b00d5d11bedff11e8d4cf2",
    name: "Holiday",
    value: "Holiday"
  },
  OVERTIME: {
    id: "68b00d5d11bedff11e8d4cf3",
    name: "Overtime",
    value: "overTime"
  },
  EXTRATIME: {
    id: "68b00d5d11bedff11e8d4cf4",
    name: "Extratime",
    value: "extraTime"
  },
  DOUBLE_OVERTIME: {
    id: "68b00d5d11bedff11e8d4cf5",
    name: "Double Overtime",
    value: "doubleOverTime"
  }
};


export const radioLeviesLabel = [
  { label: "Amount", value: "Amount" },
  { label: "Percentage of:", value: "Percentage" },
  { label: "Per Credit", value: "PerCredit" },
];
export const radioContributionLabel = [
  { label: "Amount", value: "Amount" },
  { label: "Percentage of:", value: "Percentage" },
];

export const radioAllowance = [
  { label: "Amount", value: "Amount" },
  { label: "Percentage of: Salary", value: "Percentage" },
];

export const radioContribution = [
  { label: "Paid By Company", value: "Employer" },
  { label: "Paid By Employee", value: "Employee" },
];

export const radioLevies = [
  { label: "Paid By Company", value: "Employer" },
  { label: "Paid By Employee", value: "Employee" },
];

// constants.js

export const LABEL_WIDTH = 160;

export const CONTRIBUTION_OPTIONS = [
  "Education Credit",
  "Healthcare Credit",
  "Housing Credit",
  "Childcare Credit",
];

export const APPLICABLE_ON_OPTIONS = [
  "Employee",
  "Employer",
  "Both",
];

export const MODE_OPTIONS = ["Amount", "Percentage"];

export const PLACEHOLDERS = {
  contribution: "Select contribution type",
  applicableOn: "Select applicable party",
  mode: "Select mode",
  employeeRate: "Enter amount or percentage",
};

export const billingCycles = [
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "semiannual", label: "Semi-Annual" },
  { value: "annual", label: "Annual" },
  { value: "yearly", label: "Yearly" },
  { value: "custom", label: "Custom" },
];

export const createPlanText = {
  titles: {
    create: "Create New Plan",
    edit: "Edit Plan",
  },
  subtitle: "Define pricing and usage limits for a subscription plan.",
  sections: {
    basic: "Basic Information",
    modules: "Modules",
  },
  placeholders: {
    planName: "Plan Name",
    billingCycle: "Billing Cycle",
    price: "Price",
    country: "Select Country",
    currency: "Select Currency",
  },
  buttons: {
    create: "Create Plan",
    update: "Update Plan",
    cancel: "Cancel",
  },
  errors: {
    planNameRequired: "Plan name is required",
    billingCycleRequired: "Billing cycle is required",
    priceRequired: "Price is required",
    priceInvalid: "Price must be a positive integer",
    countryRequired: "Country is required",
    currencyRequired: "Currency is required",
    maxEmployeesRequired: "Max employees is required",
    maxEmployeesInvalid: "Max employees must be a positive integer",
    payslipsRequired: "Payslips per year is required",
    payslipsInvalid: "Payslips per year must be a positive integer",
  },
};

export const planModuleDefaultToggles = {
  invoicing: true,
  operators: true,
  manageEmployees: true,
  attendance: true,
  loans: false,
  deductions: true,
  leaveManagement: true,
  commission: true,
  travelClaims: false,
  recruitment: true,
  timesheet: true,
  projects: false,
  payroll: true,
  salaryManagement: false,
  reports: true,
  documentsUploadPerEmployee: true,
};

export const planModuleDefaultValues = {
  companies: "",
  operatorsPerPlan: "",
  invoice: "",
  invoiceValueCap: "",
  attendanceDays: "",
  loans: "",
  deductions: "",
  leaveRequests: "",
  commissionRuns: "",
  travelClaims: "",
  allowances: "",
  employeeDocsPerEmployee: "",
  recruitment: "",
  timesheet: "",
  projects: "",
  payrollRuns: "",
  reportDownloads: "",
  exportFormats: [],
  documentsUploadPerEmployee: "",
};

export const planModuleRows = [
  {
    id: "companies",
    label: "Companies",
    hideToggle: true,
    fields: [{ key: "companies", placeholder: "Companies" }],
  },
  {
    id: "operators",
    label: "Operators",
    fields: [{ key: "operatorsPerPlan", placeholder: "Operators Per Plan" }],
  },
  {
    id: "invoicing",
    label: "Invoicing",
    fields: [
      { key: "invoice", placeholder: "Invoice" },
      { key: "invoiceValueCap", placeholder: "Invoice Value Cap" },
    ],
  },
  {
    id: "manageEmployees",
    label: "Users",
    fields: [{ key: "maxEmployees", placeholder: "Active Employees", boundToForm: "maxEmployees" }],
  },
  {
    id: "attendance",
    label: "Attendance",
    fields: [{ key: "attendanceDays", placeholder: "days per plan" }],
  },
  {
    id: "loans",
    label: "Loans",
    fields: [{ key: "loans", placeholder: "Loans" }],
  },
  {
    id: "deductions",
    label: "Deductions",
    fields: [{ key: "deductions", placeholder: "Active Deductions" }],
  },
  {
    id: "leaveManagement",
    label: "Leave Management",
    fields: [{ key: "leaveRequests", placeholder: "Leave Requests" }],
  },
  {
    id: "commission",
    label: "Commission",
    fields: [{ key: "commissionRuns", placeholder: "Commission Runs" }],
  },
  {
    id: "travelClaims",
    label: "Travel Claims & Allowances",
    fields: [
      { key: "travelClaims", placeholder: "Travel Claims" },
      { key: "allowances", placeholder: "Allowances" },
    ],
  },
  {
    id: "recruitment",
    label: "Recruitment",
    fields: [{ key: "recruitment", placeholder: "Recruitment" }],
  },
  {
    id: "timesheet",
    label: "Timesheet",
    fields: [{ key: "timesheet", placeholder: "Timesheet" }],
  },
  {
    id: "projects",
    label: "Projects",
    fields: [{ key: "projects", placeholder: "Projects" }],
  },
  {
    id: "payroll",
    label: "Payroll",
    fields: [{ key: "payrollRuns", placeholder: "Payroll Runs" }],
  },
  {
    id: "salaryManagement",
    label: "Salary Management",
    fields: [{ key: "payslipsPerYear", placeholder: "Payslips", boundToForm: "payslipsPerYear" }],
  },
  {
    id: "reports",
    label: "Reports",
    fields: [
      { key: "reportDownloads", placeholder: "Report downloads" },
      {
        key: "exportFormats",
        placeholder: "Export formats",
        type: "select",
        multiple: true,
        options: ["PDF", "CSV", "Excel"],
      },
    ],
  },
  {
    id: "documentsUploadPerEmployee",
    label: "Document Uploads (Per Employee)",
    hideToggle: true,
    fields: [
      { key: "documentsUploadPerEmployee", placeholder: "Documents per employee" },
    ],
  },
];

export const planManagementText = {
  title: "Plan Management",
  subtitle: "Create and manage subscription plans available to clients.",
  createButton: "+ Create New Plan",
  emptyMessage: "No plans found",
  disableModalTitle: "Disable Plan",
  disableModalBody: "Are you sure you want to disable this plan?",
  disableModalConfirm: "Disable",
  deleteModalTitle: "Delete Plan",
  deleteModalBody: "Are you sure you want to delete this plan?",
  deleteModalConfirm: "Delete",
  modalTitle: "Delete Plan",
  modalBody: "Are you sure you want to delete this plan?",
  modalConfirm: "Delete",
  modalCancel: "Cancel",
  tableHeaders: [
    "Plan Name",
    "Billing Cycle",
    "Employee Limit",
    "Payslips Limit",
    "Price",
    "Actions",
    "Active/Inactive",
  ],
  fallbacks: {
    planName: "Starter",
    billingCycle: "Yearly",
    employeeLimit: 25,
    payslipLimit: 300,
    price: "$499",
  },
};

export const forgotPasswordData = {
  email: {
    value: "",
    error: "",
    focus: null,
  },
};

export const resetPasswordData = {
  newPassword: {
    value: "",
    error: "",
    focus: null,
  },
  confirmPassword: {
    value: "",
    error: "",
    focus: null,
  },
};
